<p-table
	[value]="invoices"
	[paginator]="false"
	[rows]="10"
	[responsiveLayout]="'scroll'"
	[tableStyle]="{ 'min-width': '40rem' }"
	[loading]="loading"
>
	<ng-template pTemplate="header">
		<tr>
			<th style="width: 180px">Date</th>
			<th style="width: 180px">Due Date</th>
			<th>Invoice</th>
			<th style="width: 150px">Amount Due</th>
			<th style="width: 150px">Status</th>
			<th style="width: 160px; text-align:right">Actions</th>
		</tr>
	</ng-template>

	<ng-template pTemplate="body" let-row>
		<tr>
			<td>{{ row.date | DateLocalFormat: false }}</td>
			<td>{{ row.dueDate | DateLocalFormat: false }}</td>
			<td>
				{{ row.invoiceNumber }}
			</td>
			<td style="width: 150px">{{ row.amountDue > 0 ? (row.amountDue | currency:'AUD':'symbol':'1.2-2') : '' }}</td>
			<td>
				<p-tag [value]="row.isOutstanding ? 'Outstanding' : (row.isPaid ? 'Paid' : row.status)"
							 [severity]="row.isOutstanding ? 'warning' : (row.isPaid ? 'success' : 'info')"></p-tag>
			</td>
			<td style="text-align:right">
				<a href="javascript:void(0)" (click)="download.emit({invoice: row, download: false})">Download Invoice</a>
			</td>
		</tr>
	</ng-template>

	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="6" class="text-center">
				{{ loading ? '' : 'No invoices found.' }}
			</td>
		</tr>
	</ng-template>
</p-table>
